module.exports = __webpack_public_path__ + "img/the-killing-moon.33c6731c.png";